import {Component, DoCheck, EventEmitter, Input, IterableDiffers, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Entity} from '../../../../models/entity.model';
import {EntitiesTypes} from '../../../../models/htmlDocument.model';

@Component({
  selector: 'app-entities-bar',
  templateUrl: './entities-bar.component.html',
  styleUrls: ['./entities-bar.component.scss']
})
export class EntitiesBarComponent implements OnInit, OnChanges, DoCheck{
  @Input() entities: Entity[];
  @Input() labels: EntitiesTypes[] = [];
  @Input() hasEntityChange: boolean;
  @Output() deleteEntity: EventEmitter<Entity> = new EventEmitter();
  @Output() updateEntity: EventEmitter<Entity[]> = new EventEmitter();
  @Output() downloadDocument: EventEmitter<boolean> = new EventEmitter();
  groupedEntities: any = {};
  private differ: IterableDiffers;

  constructor(private differs: IterableDiffers) {
    this.differ = differs;
  }

  ngOnInit(): void {
    this.group();
  }

  delete(entity): void {
    this.deleteEntity.emit(entity);
  }

  saveEntities(): void {
    this.updateEntity.emit(this.entities);
  }

  group(): void {
    this.groupedEntities = {};
    this.entities.forEach( x => {
      if (this.groupedEntities.hasOwnProperty(x.entityType)) {
        this.groupedEntities[x.entityType].push(x);
      } else {
        this.groupedEntities[x.entityType] = [x];
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.group();
  }

  ngDoCheck(): void {
    const changes = this.differ.find(this.entities);
    if (changes) {
      this.group();
    }
  }

  download() {
    this.downloadDocument.emit(true);
  }

}
